const page = {
  namespaced: true,
  state: {
    coverageList: null,

    monthSatelliteView: [],
    seasonSatelliteView: [],
    yearSatelliteView: [],

    monthSatelliteCover: [],
    seasonSatelliteCover: [],
    yearSatelliteCover: [],

    dataTrend: null,
    trendPeriod: null,
  },
  getters: {
    coverageList: state => state.coverageList,

    monthSatelliteView: state => state.monthSatelliteView,
    seasonSatelliteView: state => state.seasonSatelliteView,
    yearSatelliteView: state => state.yearSatelliteView,

    monthSatelliteCover: state => state.monthSatelliteCover,
    seasonSatelliteCover: state => state.seasonSatelliteCover,
    yearSatelliteCover: state => state.yearSatelliteCover,

    dataTrend: state => state.dataTrend,
    trendPeriod: state => state.trendPeriod,
  },
  mutations: {
    SET_COVERAGE_LIST(state, o) {
      state.coverageList = o
    },

    SET_MONTH_SATELLITE_VIEW(state, o) {
      state.monthSatelliteView = o
    },
    SET_SEASON_SATELLITE_VIEW(state, o) {
      state.seasonSatelliteView = o
    },
    SET_YEAR_SATELLITE_VIEW(state, o) {
      state.yearSatelliteView = o
    },

    SET_MONTH_SATELLITE_COVER(state, o) {
      state.monthSatelliteCover = o
    },
    SET_SEASON_SATELLITE_COVER(state, o) {
      state.seasonSatelliteCover = o
    },
    SET_YEAR_SATELLITE_COVER(state, o) {
      state.yearSatelliteCover = o
    },

    SET_DATA_TREND(state, o) {
      state.dataTrend = o
    },
    SET_TREND_PERIOD(state, o) {
      state.trendPeriod = o
    },
  },
  actions: {
  },
}

export default page
